__turbopack_context__.v({
  "closeBtn": "styles-module-scss-module__HtipXa__closeBtn",
});
